
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M18.51 7.72a5.08 5.08 0 0 0-1.317-4.913A5.08 5.08 0 0 0 12.28 1.49 5.08 5.08 0 0 0 7.367.175 5.08 5.08 0 0 0 3.77 3.77 5.08 5.08 0 0 0 .175 7.367 5.08 5.08 0 0 0 1.49 12.28a5.08 5.08 0 0 0 1.317 4.913A5.08 5.08 0 0 0 7.72 18.51a5.08 5.08 0 0 0 4.913 1.316 5.08 5.08 0 0 0 3.597-3.596 5.08 5.08 0 0 0 3.596-3.597A5.08 5.08 0 0 0 18.51 7.72m-2.134-4.095A3.92 3.92 0 0 1 17.49 6.93l-4.235-2.445a.58.58 0 0 0-.577 0l-4.96 2.863V5.47c0-.131.071-.255.186-.32l3.776-2.18a3.93 3.93 0 0 1 4.695.654M10 7.367l2.28 1.317v2.633L10 12.633l-2.28-1.316V8.684zM4.752 5.03a3.933 3.933 0 0 1 6.336-3.052L6.852 4.423a.58.58 0 0 0-.288.5v5.726L4.938 9.71a.37.37 0 0 1-.186-.32zM1.291 7.666a3.92 3.92 0 0 1 2.305-2.62v4.892c0 .206.11.396.289.5L8.844 13.3l-1.626.94a.37.37 0 0 1-.37 0l-3.776-2.18A3.93 3.93 0 0 1 1.29 7.665m2.333 8.71a3.92 3.92 0 0 1-1.115-3.307l4.235 2.446a.58.58 0 0 0 .577 0l4.96-2.864v1.878c0 .132-.071.255-.186.32L8.32 17.03a3.93 3.93 0 0 1-4.695-.653m11.624-1.406a3.933 3.933 0 0 1-6.336 3.052l4.236-2.445a.58.58 0 0 0 .288-.5V9.351l1.626.939a.37.37 0 0 1 .186.32zm3.461-2.636a3.92 3.92 0 0 1-2.305 2.62v-4.891a.58.58 0 0 0-.289-.5L11.156 6.7l1.626-.939a.37.37 0 0 1 .37 0l3.776 2.18a3.93 3.93 0 0 1 1.781 4.393"}})])
          )
        }
      }
    